import env from '../../../../environment';
import {postCreator, getCreator} from '../../../../http';

export const endpoints = Object.freeze({
  SEND_MESSAGE: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/:conversationId/message`,
  GET_CONVERSATION_MESSAGES: `${env.baseApiUrl}/im/admin/crm-messaging/conversation/:conversationId/message`,
});

export const sendMessage = postCreator(endpoints.SEND_MESSAGE);

export const getConversationMessages = getCreator(
  endpoints.GET_CONVERSATION_MESSAGES
);
